import { render, staticRenderFns } from "./Appointment.vue?vue&type=template&id=50bb3d09&scoped=true"
import script from "./Appointment.js?vue&type=script&lang=js&external"
export * from "./Appointment.js?vue&type=script&lang=js&external"
import style0 from "./Appointment.vue?vue&type=style&index=0&id=50bb3d09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bb3d09",
  null
  
)

export default component.exports